export default __webpack_public_path__ + "static/realWorldImage3-bd93f6705a882911c7862ba3407bb4b4.webp";